<template>
  <div class="membresias">
    <v-container>
      <v-row>
        <v-col>
          <v-breadcrumbs :items="items" :divider="'|'" class="py-0 pl-0">
            <template v-slot:item="props">
              <v-breadcrumbs-item :to="props.item.to" :class="[props.item.disabled && 'disabled']">
                <span style="color: black;">{{ props.item.text }}</span>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-center">
          <h1 class="PTSerif" style="font-size: 20px;">Academia</h1>
          <p
            style="max-width: 450px;"
            class="d-block mx-auto my-3"
          >En nuestra academia queremos compartir contigo información, practicas y tips que te permitan convivir y trabajar de una mejor manera con nuestros recursos naturales.</p>
        </v-col>
      </v-row>




      <v-row justify="center" class="pb-12" v-for="(curso,c) in cursos" :key="'curso'+c">
        <v-col cols="12" md="12" xl="8">
          <v-row no-gutters align="center" style="background-color: #EFEDE9;">
            <v-col cols="12" md="6">
              <v-img :src="'https://flordeazaharcms.actstudio.xyz/'+curso.imagen.path" width="100%"></v-img>
            </v-col>
            <v-col cols="12" md="6" class="my-12 my-md-0">
              <div class="mx-auto taller-verano-max-width padding-custom-academia">
                <h2 class="mb-6 PTSerif bold title-taller-academia">{{curso.nombre}}</h2>
                
                <div v-html="curso.descripcion">
                </div>

              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-btn color="#343434" width="100%" tile elevation="0" class="d-sm-none" :ripple="false">
              <span style="color:white; font-size:10px;">horarios y precios</span>
              <v-icon color="white" style="position:absolute; right:0;">mdi-chevron-down</v-icon>
            </v-btn>
            <v-col cols="12" sm="4" style="background-color: #56604D; color: white;" v-for="(paquete,p) in curso.paquetes" :key="'paquete'+p">
              <div class="horarios-max-width">

                
                <span class="d-block mb-3 title-horarios">{{paquete.value.titulo}}</span>

                <div class="pb-6" id="horarios" v-html="paquete.value.description">
                  <!-- <ul class="pl-0" style="list-style:none;">
                    <li><span class="bold">Horario</span></li>
                    <li><span class="bold">Grupo 1</span></li>
                    <li><span class="bold">Grupo 2</span></li>
                    <li><span class="bold">Grupo 3</span></li>
                  </ul>
                  <ul style="list-style:none;">
                    <li><span>9:00 AM — 1:00 PM</span></li>
                    <li><span>15 al 19 de Julio</span></li>
                    <li><span>22 al 26 de Julio</span></li>
                    <li><span>29 de Julio al 2 de Agosto</span></li>
                  </ul> -->
                </div>
                
                <span class="academia-precios">{{paquete.value.precio}}</span>

                <!-- inicia botón en pantallas chicas -->
                <div class="pt-9 pb-4 d-sm-none">
                  <v-btn
                  to="/contacto"
                    rounded
                    height="24px"
                    elevation="0"
                    dark
                    color="#B4613D"
                    class="px-8"
                    style="width: 100%;"
                  >Contáctanos</v-btn>
                </div>
                <!-- termina botón en pantallas chicas -->
              </div>
            </v-col>

            
          </v-row>
          <v-row no-gutters class="d-none d-sm-flex">
            <v-col cols="12">
              <router-link to="/contacto" style="text-decoration: none;">
                <v-btn block tile elevation="0" color="#B4613D" dark>CONTACTANOS</v-btn>
              </router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          text: "Inicio",
          disabled: false,
          href: "/"
        },
        {
          text: "Academia",
          disabled: true
        }
      ],
      cursos: []
    };
  },
  beforeMount: function(){
    fetch("https://flordeazaharcms.actstudio.xyz/api/collections/get/Academia?token=bd38a532024ddfd195a5fdefd8eb98",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          populate: 2 // resolve linked collection items
        })
      }
    )
    .then(res => res.json())
    .then(res => (this.cursos = res.entries));
  }
};
</script>